import QuestionCopyButton from './QuestionCopyButton';

export default QuestionCopyButton;
